module.exports = {template: '<svg width="49" height="54" viewBox="0 0 49 54" xmlns="http://www.w3.org/2000/svg"><path d="M48.878 13.942L49.001.879l-5.082 5.082C39.138 2.101 33.231 0 27 0 19.788 0 13.008 2.808 7.908 7.908 2.808 13.007 0 19.788 0 27c0 7.211 2.808 13.991 7.908 19.091C13.008 51.191 19.788 54 27 54c7.211 0 13.992-2.809 19.091-7.909l-2.828-2.828A22.85 22.85 0 0 1 27 50a22.854 22.854 0 0 1-16.264-6.737A22.85 22.85 0 0 1 4 27a22.85 22.85 0 0 1 6.736-16.264A22.853 22.853 0 0 1 27 4a22.819 22.819 0 0 1 14.059 4.82l-5.244 5.245 13.063-.123z" fill-rule="evenodd"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./static/svg/rotate.svg
// module id = 1818
// module chunks = 11